import { PayloadAction } from "@reduxjs/toolkit";

import { ActivationEmailKeys, LocalStorageKeys } from "@sso/constant";
import { AuthState, GetSessionResponse, LoginResponse } from "@sso/types";
import { localStorageHelper } from "@sso/utils";

export const authReducers = {
  logOutUser: () => {
    localStorageHelper.removeItem(LocalStorageKeys.TOKEN);
  },
  logInUser: (auth: AuthState, action: PayloadAction<LoginResponse>) => {
    const { user, token, organisation, role } = action.payload;
    if (user) {
      auth.currentUser = { ...user, organisation, role };
    }
    if (token) {
      localStorageHelper.storeItem(LocalStorageKeys.TOKEN, token);
    }
  },
  getUserFromSession: (auth: AuthState, action: PayloadAction<GetSessionResponse>) => {
    const {
      authUser: { user, organisation, role },
    } = action.payload;
    auth.currentUser = { ...user, organisation, role };
  },
  setActivationEmailStatus: (auth: AuthState, action: PayloadAction<ActivationEmailKeys>) => {
    auth.activationEmailStatus = action.payload;
  },
  updateProfilePicture: (auth: AuthState, action: PayloadAction<string>) => {
    if (!auth.currentUser) {
      return;
    }
    if (auth.currentUser.picture?.startsWith("blob")) {
      URL.revokeObjectURL(auth.currentUser.picture);
    }
    auth.currentUser.picture = action.payload;
  },
};
